
import { useEffect, useState } from "react";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import BookingsList from "@/components/bookings/BookingsList";
import TermsPopup from "@/components/TermsPopup";
import ChatSupport from "@/components/chat/ChatSupport";
import { useToast } from "@/hooks/use-toast";
import Footer from "@/components/Footer";

const Index = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Load Tawk.to script
    const script = document.createElement("script");
    script.async = true;
    script.src = 'https://embed.tawk.to/67a463433a842732607a68fc/1ijd27gon';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.head.appendChild(script);

    const initializePage = async () => {
      try {
        setIsLoading(false);
      } catch (error) {
        console.error("Error initializing page:", error);
        toast({
          title: "Error",
          description: "There was a problem loading the page. Please try again.",
          variant: "destructive",
        });
        setIsLoading(false);
      }
    };

    initializePage();

    // Cleanup
    return () => {
      document.head.removeChild(script);
    };
  }, [toast]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        <Hero />
        <Features />
        
        {/* About Us Section */}
        <section className="bg-slate-50 py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-8">About Us</h2>
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-lg mb-6">
                Welcome to Easy Parking, your solution to the daily parking hassles. We connect drivers with available parking spaces in crowded urban areas, helping you save time and reduce stress.
              </p>
              <p className="text-lg mb-6">
                Our platform allows property owners to list their unused parking spots, creating additional income while helping solve parking shortages in busy neighborhoods. Whether you're looking for a spot for a few hours or need regular parking, we've got you covered.
              </p>
              <p className="text-lg">
                With secure payment processing, real-time availability updates, and a user-friendly interface, Easy Parking makes finding and reserving parking spots simple and convenient. Join our community today and experience hassle-free parking!
              </p>
            </div>
          </div>
        </section>
        
        <div className="container mx-auto px-4 py-8">
          <h2 className="text-2xl font-semibold mb-6">Your Bookings</h2>
          <BookingsList />
        </div>
      </div>
      <Footer />
      <TermsPopup />
      <ChatSupport />
    </div>
  );
};

export default Index;
